import React, { useEffect, useState} from 'react';
import Mapir from 'mapir-react-component';

const Map = Mapir.setToken({
    transformRequest: url => {
        return { 
            url: url,
      headers: { 
          'x-api-key': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6Ijg3MzUwNWY0NmMwM2I1M2NiYzU1ZDdhNzIwN2Y4OWM0NDJlYzNhNzEzYTM3YmUxZDg3YmZhN2UzODI5YWNkYzIyMGYyYWQ3ZmU3ZDBlZWY0In0.eyJhdWQiOiIxNTE2OCIsImp0aSI6Ijg3MzUwNWY0NmMwM2I1M2NiYzU1ZDdhNzIwN2Y4OWM0NDJlYzNhNzEzYTM3YmUxZDg3YmZhN2UzODI5YWNkYzIyMGYyYWQ3ZmU3ZDBlZWY0IiwiaWF0IjoxNjQ5NjY5MTQ5LCJuYmYiOjE2NDk2NjkxNDksImV4cCI6MTY1MDcwNTk0OSwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.QtGGJZjSmZZYG_sss24KJ8XjqiWorsya-emnAMHMX2iaKZEK9Uw_IMmRU3EZFqpSo0r-ueXxFs4EcT9WJobwyMafHnHjTC9yBcICHjh-imGWqjuyE5Xr487-ZAAWuQ1GvT4gTRxFdfMUFDe0wsjY8eNmqYPkcfslJnsyWgUO_GcZsg_xnWpyRdJbPaWWDEr9if1SpjGGEXSmQjWU-psCCwy2wIB4CL1xLvMrT3mHBqx2mp7RrO82gOVD9obnZYGjIXDBa9v1CCqnbjhkqOVDW4_kcnC8UNdHsNvdnRXhJEV3eIhdmEJzIX9IG1DwfC3cpm_a8xm_NzQK-g27lWfHJQ',
          'Mapir-SDK': 'reactjs'
      }
    };
}
});
export default function LiveLocationMap(props) {
  const [zoom, setZoom] = useState(13);
  const [, setLon] = useState(null);
  const [, setLat] = useState(null);
  const [$select, set$select] = useState('poi,city,roads,neighborhood');
  const [center, setCenter] = useState([53.54347,36.69056]);
  const [markerArray, setMarkerArray] = useState([])
  const [nearby, setNearby] = useState({
    active: false,
    coordinates: null
  });
  let arr=[
    {
        lat:53.543541,
        lng:36.698051
    },
    {
        lat:53.545342,
        lng:36.690532
    },
    // {
    //     lat:53.547343,
    //     lng:36.6908953
    // },
    // {
    //     lat:53.574344,
    //     lng:36.690584
    // },
    // {
    //     lat:53.543405,
    //     lng:36.690535
    // },
    // {
    //     lat:53.543346,
    //     lng:36.692056
    // },
    // {
    //     lat:53.5744347,
    //     lng:36.691057
    // },
]
const MINUTE_MS=10000
useEffect(() => { 
      let randomarrr = arr[Math.floor(Math.random()*arr.length)]
    //const interval = setInterval(() => {
    //    mapClickHandler(randomarrr)
    //  }, MINUTE_MS);
     // return () => clearInterval(interval)
  },[]);

  function mapClickHandler(e) {
    console.log(e)
    setCenter([e.lat,e.lng])
    setTimeout(() => {
      setZoom(15)
    }, 1000);
    localStorage.setItem("checkMarker",true)
    reverseFunction(e)
    if (nearby.active) {
      setNearby({
        ...nearby,
        coordinates: [e.lat,e.lng]
      });
      setLon(e.lng);
      setLat(e.lat);
      let s = $select;
      if (!$select.includes('nearby')) {
        let sa = $select.split(',');
        sa.push('nearby');
        s = sa.filter(item => item !== '').join(',');
      }
      set$select(s);
    }
  }

  function reverseFunction(e) {
    var url = `https://map.ir/reverse/no?lat=${e.lat}&lon=${e.lng}`;
    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6Ijg3MzUwNWY0NmMwM2I1M2NiYzU1ZDdhNzIwN2Y4OWM0NDJlYzNhNzEzYTM3YmUxZDg3YmZhN2UzODI5YWNkYzIyMGYyYWQ3ZmU3ZDBlZWY0In0.eyJhdWQiOiIxNTE2OCIsImp0aSI6Ijg3MzUwNWY0NmMwM2I1M2NiYzU1ZDdhNzIwN2Y4OWM0NDJlYzNhNzEzYTM3YmUxZDg3YmZhN2UzODI5YWNkYzIyMGYyYWQ3ZmU3ZDBlZWY0IiwiaWF0IjoxNjQ5NjY5MTQ5LCJuYmYiOjE2NDk2NjkxNDksImV4cCI6MTY1MDcwNTk0OSwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.QtGGJZjSmZZYG_sss24KJ8XjqiWorsya-emnAMHMX2iaKZEK9Uw_IMmRU3EZFqpSo0r-ueXxFs4EcT9WJobwyMafHnHjTC9yBcICHjh-imGWqjuyE5Xr487-ZAAWuQ1GvT4gTRxFdfMUFDe0wsjY8eNmqYPkcfslJnsyWgUO_GcZsg_xnWpyRdJbPaWWDEr9if1SpjGGEXSmQjWU-psCCwy2wIB4CL1xLvMrT3mHBqx2mp7RrO82gOVD9obnZYGjIXDBa9v1CCqnbjhkqOVDW4_kcnC8UNdHsNvdnRXhJEV3eIhdmEJzIX9IG1DwfC3cpm_a8xm_NzQK-g27lWfHJQ'
      }
    })
      .then(response => response.json())
      .then(data => {
    //   localStorage.setItem('lon',data.geom.coordinates[1])
    //   localStorage.setItem('lat',data.geom.coordinates[0]) 
    //   localStorage.setItem('address_compact',data.address_compact)
      });
    const array = [];
    array.push(
      <Mapir.Marker
        coordinates={[e.lat,e.lng]}
        Image={"Assets/Images/map/marker1.png"}
        key={0}
        />
    );
    setMarkerArray(array);
  }

  return (
    <>
      <div className="App">
        <Mapir
          center={center}
          zoom={[zoom]}
          Map={Map}
          userLocation
        >
          {markerArray}
        </Mapir>
      </div>
    </>
  );
}